import Login from "../view/login";
import HomeView from "../view/home";
import Page from "../view/page"
import His from "../view/his"
import HisDetail from "../view/his/detail";
import Mine from "../view/mine"
import Check from "../view/check";
import Shop from "../view/shop";
import ShopEdit from "../view/shop/edit";
import Sales from "../view/sales";
import SalesEdit from "../view/sales/edit";
import Cook from "../view/cook";
import CookEdit from "../view/cook/edit";
import Download from "../view/download";
import Device from "../view/device";
import DishViewer from "../view/dish/viewer";

const ROUTER_LIST = [
  {
    path: '/',
    element: <Login/>
  },
  {
    path: '/page',
    element: <HomeView children={<Page />} />
  },
  {
    path: '/his',
    element: <HomeView children={<His />} />
  },
  {
    path: '/his/detail',
    element: <HisDetail />
  },
  {
    path: '/mine',
    element: <HomeView children={<Mine />} />
  },
  {
    path: '/check',
    element: <Check/>
  },
  {
    path: '/shop',
    element: <Shop/>
  },
  {
    path: '/shop/edit',
    element: <ShopEdit/>
  },
  {
    path: '/sales',
    element: <Sales/>
  },
  {
    path: '/sales/edit',
    element: <SalesEdit/>
  },
  {
    path:'/cook',
    element: <Cook/>
  },
  {
    path:'/cook/edit',
    element: <CookEdit/>
  },
  {
    path: '/d',
    element: <Download/>
  },
  {
    path: '/download',
    element: <Download/>
  },
  {
    path: '/device',
    element: <Device/>
  },
  {
    path: '/dish/viewer',
    element: <DishViewer/>
  }
];

export default ROUTER_LIST;